import type { ComponentProps } from "react";
import { FormMessage } from "@acdc2/ui/components/access-form";
import { useTranslation } from "react-i18next";

type Props = Omit<ComponentProps<typeof FormMessage>, "match">;

export function ValueMissingFormMessage(props: Props) {
  const { t } = useTranslation();

  return (
    <FormMessage match="valueMissing" {...props}>
      {t("ValueMissingFormMessage.message")}
    </FormMessage>
  );
}
